import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClock } from "@fortawesome/free-regular-svg-icons";
import { faLocationDot } from "@fortawesome/free-solid-svg-icons";
import styles from "./index.module.scss";
export var Info = function () {
    return React.createElement("div", { className: styles.container },
        React.createElement("div", { className: "title" }, "Informations"),
        React.createElement("div", { className: styles.subcontainer },
            React.createElement("div", { className: styles.info },
                React.createElement(FontAwesomeIcon, { icon: faClock }),
                React.createElement("div", { className: styles.title }, "QUAND"),
                React.createElement("div", null, "Samedi"),
                React.createElement("div", { className: styles.last }, "17 d\u00E9cembre 2022 \u00E0 11h")),
            React.createElement("div", { className: styles.info },
                React.createElement(FontAwesomeIcon, { icon: faLocationDot }),
                React.createElement("div", { className: styles.title }, "OU"),
                React.createElement("div", null, "\u00C9tampes, 91"),
                React.createElement("div", { className: styles.last }, "Carrefour des religieuses"))));
};
